/** Path to the native roof cost calculator. */
export const CALCULATOR_PATH = "/roof-cost-estimate";
